// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__UGH8f","label":"Section_label__1VOwc","contentWrap":"Section_contentWrap__2kc7R","footer":"Section_footer__38Z11","footerInner":"Section_footerInner__LaeL9"};